<div class="row form-row">
  <div class="title-and-save">
    <h2 class="metric-fields">Metric Fields</h2>
    <button
      mat-raised-button
      class="save-changes-btn green-btn"
      (click)="saveChangesEvent.emit()"
      *ngIf="metrics?.changesToSave?.titleAndDesc"
      [disabled]="metrics?.pending"
    >
      SAVE
    </button>
    <p
      *ngIf="metrics?.savedSuccessfully?.titleAndDesc"
      class="green-text fields-saved-text"
    >
      Saved!
    </p>
    <p
      *ngIf="metrics?.errors?.titleAndDesc"
      class="general-error metric-fields-error"
    >
      {{ metrics?.errors?.titleAndDesc }}
    </p>
  </div>
  <p *ngIf="metrics?.pending" class="green-text save-in-progress-text">
    Loading...
  </p>
  <text-area-input-element
    [label]="'metric name'"
    [rows]="'1'"
    [maxChars]="'75'"
    [value]="metrics?.updatedSelectedMetric?.long_name"
    (textAreaUpdated)="metricNameEvent.emit($event)"
  ></text-area-input-element>
  <text-area-input-element
    [label]="'metric description'"
    [rows]="'7'"
    [maxChars]="'300'"
    [value]="metrics?.updatedSelectedMetric?.definition"
    (textAreaUpdated)="metricDescEvent.emit($event)"
  ></text-area-input-element>
</div>
